import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

const KofiModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden" data-testid="kofi-modal">
        <DialogHeader className="p-4 pb-0">
          <DialogTitle className="flex items-center gap-2">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#FF5E5B">
              <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.658-3.734 4.352.24 7.422-2.831 6.649-6.916zm-11.062 3.511c-1.246 1.453-4.011 3.976-4.011 3.976s-.121.119-.31.023c-.076-.057-.108-.09-.108-.09-.443-.441-3.368-3.049-4.034-3.954-.709-.965-1.041-2.7-.091-3.71.951-1.01 3.005-1.086 4.363.407 0 0 1.565-1.782 3.468-.963 1.904.82 1.832 3.011.723 4.311zm6.173.478c-.928.116-1.682.028-1.682.028V7.284h1.77s1.971.551 1.971 2.638c0 1.913-.985 2.667-2.059 3.015z"/>
            </svg>
            Support OreStore
          </DialogTitle>
        </DialogHeader>
        <div className="px-4 pb-2">
          <p className="text-xs text-muted-foreground">
            Help keep hosting running. No additional benefits for supporters - just our gratitude!
          </p>
        </div>
        <div className="w-full">
          <iframe 
            id="kofiframe" 
            src="https://ko-fi.com/orestore/?hidefeed=true&widget=true&embed=true&preview=true" 
            style={{ border: 'none', width: '100%', padding: '4px', background: '#f9f9f9' }}
            height="712" 
            title="orestore"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KofiModal;
